<template>
  <div class="container mt-4">
    <h2 class="text-center mb-5">
      I Jornada de Integración Regional - Región Cuyo - Programa Gestión
      Ambiental
    </h2>

    <div class="d-flex justify-content-center mb-4 flex-wrap">
      <button class="btn btn-orange mx-2 mb-2 fs-4" @click="showForm">
        <i class="bi bi-person-badge fs-2 me-2"></i> Acreditaciones
      </button>
      <button class="btn btn-white mx-2 mb-2 fs-5" @click="showAgenda(1)">
        <i class="bi bi-calendar-event fs-2 me-2"></i> Agenda 05/06/25
      </button>
      <button class="btn btn-orange mx-2 mb-2 fs-5" @click="showAgenda(2)">
        <i class="bi bi-calendar-event fs-2 me-2"></i> Agenda 06/06/25
      </button>
    </div>

    <!-- Mostrar solo si se elige el form -->
    <div v-if="currentView === 'form'">
      <div class="iframe-wrapper">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLScPMPjf2u9cp2ycBR852vFVFIH5NH_QWvu-pGDxldQbAmlgkQ/viewform?embedded=true"
          frameborder="0"
          allowfullscreen
          loading="lazy"
          >Cargando…</iframe
        >
      </div>
    </div>

    <!-- Mostrar solo si se elige una agenda -->
    <div v-else-if="currentView.startsWith('agenda')">
      <div v-if="pdfUrl">
        <iframe
          :src="pdfUrl"
          width="100%"
          height="800px"
          frameborder="0"
        ></iframe>
      </div>
      <div v-else class="text-center mt-5">
        <div
          class="spinner-border text-warning"
          role="status"
          style="width: 4rem; height: 4rem"
        >
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-3">Cargando contenido, por favor espere...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntegracionRegional",
  data() {
    return {
      currentView: "", // <- al inicio no muestra nada
      pdfUrl: "",
    };
  },
  methods: {
    showForm() {
      this.currentView = "form";
      this.pdfUrl = "";
    },
    async showAgenda(agendaId) {
      this.currentView = `agenda${agendaId}`;
      this.pdfUrl = "";

      const apiUrl = process.env.VUE_APP_DIRECTUS_API_URL;
      const assetsUrl = process.env.VUE_APP_DIRECTUS_ASSETS_URL;

      try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Error en la petición");

        const result = await response.json();
        const data = result.data;
        console.log("Datos obtenidos:", data);

        const pdfEntry = data.find((item) => item.id === agendaId);

        if (pdfEntry && pdfEntry.url_pdf) {
          this.pdfUrl = `${assetsUrl}/${pdfEntry.url_pdf}`;
        } else {
          console.warn(`No se encontró PDF para agenda con id ${agendaId}`);
        }
      } catch (error) {
        console.error("Error al cargar el PDF:", error);
      }
    },
  },
};
</script>

<style scoped>
.iframe-wrapper {
  max-width: 900px;
  margin: 20px auto;
  height: 1500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.iframe-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.btn-orange {
  background-color: #ff7f00;
  color: white;
}

.btn-white {
  background-color: white;
  color: black;
  border: 1px solid #ccc;
}

.btn {
  padding: 25px 35px;
}

.mt {
  margin-top: 90px;
}
</style>
